"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkText = exports.NormalText = exports.textTransform = exports.extractTextTransforms = exports.fontStyle = exports.fontWeight = exports.extractFontStyle = exports.extractFontWeights = exports.LabelText = exports.HintText = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../helpers/StyledFunctions");
const styles_1 = require("../styles");
const Flex_1 = tslib_1.__importStar(require("./Elements/Flex"));
exports.HintText = (0, styled_components_1.default)('div') `
  color: ${props => (props.error ? styles_1.Colors.Danger : styles_1.Colors.Gray)};
  font-size: 0.75rem;
  margin-top: 0.125rem;
  margin-bottom: 0.3215rem;
  user-select: none;
`;
exports.LabelText = (0, styled_components_1.default)('div') `
  color: ${styles_1.Colors.Dark};
  font-size: 0.75rem;
  margin-bottom: 0.3215rem;
  font-weight: 600;
`;
const getAlign = (props) => {
    if (props.center) {
        return `
      justify-content: center;
      text-align: center;
    `;
    }
    if (props.right) {
        return `
      justify-content: flex-end;
      text-align: right;
    `;
    }
    return '';
};
const getColor = (props) => {
    if (props.primary) {
        return `
      color: ${styles_1.Colors.Primary};
    `;
    }
    if (props.danger) {
        return `
      color: ${styles_1.Colors.Danger};
    `;
    }
    if (props.secondary) {
        return `
      color: ${styles_1.Colors.Gray};
    `;
    }
    if (props.dark) {
        return `
      color: ${styles_1.Colors.Dark};
    `;
    }
    if (props.green) {
        return `
      color: ${styles_1.Colors.Success};
    `;
    }
    if (props.red) {
        return `
      color: ${styles_1.Colors.Danger};
    `;
    }
    if (props.white) {
        return `
      color: ${styles_1.Colors.White};
    `;
    }
    return `
    color: ${styles_1.Colors.Black};
  `;
};
const fontWeightKeys = ['extraBold', 'bold', 'medium', 'regular', 'light'];
const fontStyleKeys = ['normal', 'italic'];
const extractFontWeights = (props) => (0, StyledFunctions_1.extractPropsByKeys)(props, fontWeightKeys);
exports.extractFontWeights = extractFontWeights;
const extractFontStyle = (props) => (0, StyledFunctions_1.extractPropsByKeys)(props, fontStyleKeys);
exports.extractFontStyle = extractFontStyle;
const fontWeight = (props) => {
    if (props.extraBold) {
        return 'font-weight: 800;';
    }
    if (props.bold) {
        return 'font-weight: bold;';
    }
    if (props.medium) {
        return 'font-weight: 500;';
    }
    if (props.light) {
        return 'font-weight: 300;';
    }
    if (props.regular) {
        return 'font-weight: normal;';
    }
    return '';
};
exports.fontWeight = fontWeight;
const fontStyle = (props) => {
    if (props.italic) {
        return 'font-style: italic;';
    }
    return 'font-style: normal;';
};
exports.fontStyle = fontStyle;
const textTransformKeys = ['uppercase', 'lowercase', 'capitalize'];
const extractTextTransforms = (props) => (0, StyledFunctions_1.extractPropsByKeys)(props, textTransformKeys);
exports.extractTextTransforms = extractTextTransforms;
const textTransform = (props) => {
    if (props.uppercase) {
        return 'text-transform: uppercase;';
    }
    if (props.lowercase) {
        return 'text-transform: lowercase;';
    }
    if (props.capitalize) {
        return 'text-transform: capitalize;';
    }
    return '';
};
exports.textTransform = textTransform;
exports.NormalText = (0, styled_components_1.default)(Flex_1.default) `
  align-items: center;
  line-height: 1.5;
  font-size: ${props => (props.size ? props.size : 'inherit')};
  letter-spacing: 0;
  ${exports.textTransform}
  ${exports.fontWeight}
  ${exports.fontStyle}
  ${getColor}
  ${getAlign}
`;
exports.LinkText = (0, styled_components_1.default)(Flex_1.LinkFlex) `
  align-items: center;
  line-height: 1.5;
  font-size: ${props => (props.size ? props.size : 'inherit')};
  letter-spacing: 0;
  ${exports.textTransform}
  ${exports.fontWeight}
  ${exports.fontStyle}
  ${getColor}
  ${getAlign}
  &:hover {
    text-decoration: underline;
  }
`;
